import { makeAutoObservable } from 'mobx';

import { CreditApi } from '../api/CreditApi';

export class CreditStore {
  api: CreditApi;
  initialCreditValue: number = 0;
  referralCreditValue: number = 0;
  loading: boolean = false;
  loadingReferral: boolean = false;
  enableBoosters: boolean = false;

  constructor() {
    this.api = new CreditApi();
    makeAutoObservable(this, undefined, { autoBind: true });
  }

  setInitialCreditValue(value: number) {
    this.initialCreditValue = value;
  }

  setReferralCreditValue(value: number) {
    this.referralCreditValue = value;
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  setLoadingReferral(loading: boolean) {
    this.loadingReferral = loading;
  }

  setEnableBoosters(enable: boolean) {
    this.enableBoosters = enable;
  }

  async fetchInitialCredit() {
    this.setLoading(true);
    try {
      const credit = await this.api.getInitialCreditValue();
      this.setInitialCreditValue(credit);
    } catch (error) {
      console.error('Error fetching credit:', error);
    } finally {
      this.setLoading(false);
    }
  }

  async fetchEnableBoosters() {
    try {
      const enable = await this.api.getEnableBoosters();
      this.setEnableBoosters(enable);
    } catch (error) {
      console.error('Error fetching enable boosters:', error);
    }
  }

  async updateEnableBoosters(enable: boolean) {
    try {
      await this.api.updateEnableBoosters(enable);
      this.setEnableBoosters(enable);
    } catch (error) {
      console.error('Error updating enable boosters:', error);
    }
  }

  async fetchReferralCredit() {
    this.setLoadingReferral(true);
    try {
      const credit = await this.api.getReferralCreditValue();
      this.setReferralCreditValue(credit);
    } catch (error) {
      console.error('Error fetching referral credit:', error);
    } finally {
      this.setLoadingReferral(false);
    }
  }

  async updateInitialCredit(value: number) {
    this.setLoading(true);
    try {
      await this.api.updateInitialCreditValue(value);
      this.setInitialCreditValue(value);
    } catch (error) {
      console.error('Error updating credit:', error);
    } finally {
      this.setLoading(false);
    }
  }

  async updateReferralCredit(value: number) {
    this.setLoadingReferral(true);
    try {
      await this.api.updateReferralCreditValue(value);
      this.setReferralCreditValue(value);
    } catch (error) {
      console.error('Error updating referral credit:', error);
    } finally {
      this.setLoadingReferral(false);
    }
  }
}
